import React, { useContext } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {
  MobileTabBar
} from 'components';

import './profile-general.less';

import {Tabs} from 'antd';

import RightChevronIcon from 'assests/icons/right-chevron.icon';
import { DimensionsContext } from 'context/dimensions.context';
import { useDispatch, useSelector } from 'react-redux';
import { logoutUnAuth,logoutPure } from 'services/login.service';


const { TabPane } = Tabs;


const Profile = () => {
  const { isTabletBig } = useContext(DimensionsContext);
  
  const {user} = useSelector(state => state.auth);
  let history = useHistory();
  const {dispatch} = useDispatch();



  function onChangeTabs(key) {
    if (key == 1) {
      history.push('/Profile');
    } else if (key == 2) {
      history.push('/Permission');
    } else if (key == 3) {
      history.push('/Title');
    } else if (key == 4) {
      history.push('/IpList');
    } else if (key == 5) 
    {
      logoutPure();
      history.push('/Login');;
    }
  }

 

  return (
   <React.Fragment>
            {isTabletBig ? (
              <div className="profile-page__menu sub-groups">
                <h2 className="box__title">Seçenekler</h2>
                <ul>
                  <li>
                    <NavLink to="./Profile" activeClassName="active">
                      <span>Profil İşlemleri</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  {(user?.masterOtp) &&
                  <li>
                    <NavLink to="./Permission" activeClassName="active">
                      <span>Yetki İşlemleri</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>}
                  <li>
                    <NavLink to="./Title" activeClassName="active">
                      <span>Ünvan İşlemleri</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  {(user?.apiUser && user?.masterOtp) &&
                    <li>
                      <NavLink to="./IpList" activeClassName="active">
                        <span>API İşlemleri</span>
                        <RightChevronIcon />
                      </NavLink>
                    </li>
                  }
                  <li>
                    <NavLink to ="/Login" onClick={()=> logoutUnAuth()} activeClassName="active">
                      <span>Çıkış</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                </ul>
              </div>
            ) : (
              <Tabs
                defaultActiveKey="3"
                onChange={onChangeTabs}
                renderTabBar={(props, Item) => {
                  return <MobileTabBar props={props} item={Item} />;
                }}
              >
                <TabPane tab="Profil İşlemleri" key="1"></TabPane>
                {(user?.masterOtp) &&
                <TabPane tab="Yetki İşlemleri" key="2"></TabPane>
                }
                <TabPane tab="Ünvan İşlemleri" key="3"></TabPane>
                {(user?.apiUser && user?.masterOtp) &&
                <TabPane tab="API İşlemleri" key="4"></TabPane>
                }
                <TabPane tab="Çıkış" key="5"></TabPane>
              </Tabs>
            )}
            </React.Fragment>
  );
};

export default Profile;
